import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

export function PasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const pass = control.value;

    return REGEX.passReset.test(pass) ? null : { invalidPassword: true };
  };
}
